import { useEditorStore } from '~/shell/Store';

/**
 * ENG-13020: the company flag that offers the editor's expanded template text
 * fields: an empty field's cue, the fields only they show, and how those save.
 * Without it, the editor edits each template as it did before them.
 */
export const TEMPLATE_TEXT_FIELDS_FLAG = 'course_editor_template_text_fields';

/** Whether these flags offer them; no flags (none answered yet) offer none. */
const offeredBy = ({ featureFlags }: { featureFlags?: string[] }) =>
  Boolean(featureFlags?.includes(TEMPLATE_TEXT_FIELDS_FLAG));

/**
 * Whether the editor's company has the flag. Read where it is needed, never
 * kept: the company answers after the editor opens, and another company or
 * course starts without it.
 */
export const templateTextFieldsEnabled = () =>
  offeredBy(useEditorStore.getState());

/** The same, for a component that redraws when the company's answer changes. */
export const useTemplateTextFields = () => useEditorStore(offeredBy);
